import React, {type CSSProperties} from 'react';
import {Tooltip as RBTooltip} from 'react-bootstrap';

type Props = {
    id?: string;
    className?: string;
    style?: CSSProperties;
    children?: React.ReactNode;
    positionLeft?: number;
    placement?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

export default function Tooltip(props: Props) {
    return <RBTooltip style={{position: 'unset', padding: 0}} className={props.className}>{props.children}</RBTooltip>;
}
